import { FC } from 'react';
import { Box } from '@qga/roo-ui/components';

import BookingAlert from 'components/BookingAlert';
import { DetailsBooking } from 'types';

interface BlockedStateMessageProps {
  booking: DetailsBooking;
}

const BlockedStateMessage: FC<BlockedStateMessageProps> = ({ booking }) => (
  <BookingAlert>
    <Box display={['block', 'inline']}>
      <strong>Changes in progress.</strong>
    </Box>{' '}
    We are currently resolving an issue with your booking.
  </BookingAlert>
);

export default BlockedStateMessage;
